import apiPaths from '../api-paths.js';

export default {
  validate({ partner, otherPartners, companyType }) {
    return axios.post(`${ apiPaths.PERSON }/partners/validate`, { partner, otherPartners, companyType });
  },
};
